import React from 'react'
import ComingSoon from './pages/ComingSoon'

export default function App() {
  return <ComingSoon />
}
